import React from "react"
import ErrorText from "@irati/ui/src/ErrorText"
import {FormattedMessage} from "@irati/utils/lang"
import {CSVErrors, CSVErrorsMessages} from "../../../enums/CsvErrors"

interface CSVErrorMessageProps {
  error?: CSVErrors | null
}
const CSVErrorMessage: React.FC<CSVErrorMessageProps> = (props) => {
  const {error} = props
  if (!error || !(error in CSVErrorsMessages)) {
    return null
  }
  const errorMessageKey = CSVErrorsMessages[error as keyof typeof CSVErrorsMessages]
  return (
    <ErrorText>
      <FormattedMessage id={errorMessageKey} />
    </ErrorText>
  )
}

export default CSVErrorMessage
